import { Navigate, useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { Card } from '../../ds/components';
import { isUnauthenticated, setupRouteFor, useSessionQuery } from '../../lib/session';
import { AuthFrame } from './AuthFrame';
import { invalidateSession, useLogout } from './auth';
import { TwoFactorSetupPanel } from './TwoFactorSetupPanel';
import styles from './TwoFactorSetupPage.module.css';

/** Mandatory 2FA setup at the first sign-in (§9.1): Einstellungen 17 as a full-frame step. */
export function TwoFactorSetupPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const session = useSessionQuery();
  const logout = useLogout();

  if (session.isError && isUnauthenticated(session.error)) return <Navigate to="/login" replace />;
  if (session.data?.setup) return <Navigate to={setupRouteFor(session.data.setup)} replace />;
  if (session.data?.twoFactorPassed || session.data?.twoFactorRequired === false)
    return <Navigate to="/home" replace />;
  if (session.data?.account.twoFactorEnabled) return <Navigate to="/login/2fa" replace />;

  async function otherAccount() {
    await logout.mutateAsync().catch(() => undefined);
    await navigate('/login', { replace: true });
  }

  return (
    <AuthFrame wide>
      <Card className={styles.card}>
        <TwoFactorSetupPanel
          variant="login"
          cancelLabel="Anderes Konto"
          onCancel={() => void otherAccount()}
          onDone={() => {
            void invalidateSession(queryClient).then(() => navigate('/home', { replace: true }));
          }}
        />
      </Card>
    </AuthFrame>
  );
}
